module.exports = __webpack_public_path__ + "static/img/m_role.df1e9ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/bz/m_role.png
// module id = YPUG
// module chunks = 7